const actions = {
  SET_STATE: 'user/SET_STATE' as const,
  LOGIN: 'user/LOGIN' as const,
  LOGIN_BY_KEY: 'user/LOGIN_BY_KEY' as const,
  LOGIN_BY_TOKEN: 'user/LOGIN_BY_TOKEN' as const,
  LOGIN_BY_ENTRY_CHECK: 'user/LOGIN_BY_ENTRY_CHECK' as const,
  LOGIN_BY_ENTRY: 'user/LOGIN_BY_ENTRY' as const,
  REGISTER: 'user/REGISTER' as const,
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT' as const,
  LOGOUT: 'user/LOGOUT' as const,
  SET_ENTRY_ERROR: 'user/SET_ENTRY_ERROR' as const,
  CLEAR_ENTRY_ERROR: 'user/CLEAR_ENTRY_ERROR' as const,
}

export default actions
